export const GET_BENEFITS_BEGIN = 'GET_BENEFITS_BEGIN'
export const GET_BENEFITS_SUCCESS = 'GET_BENEFIT_SUCCESS'
export const GET_BENEFITS_ERROR = 'GET_BENEFITS_ERROR'

export const DELETE_BENEFIT_BEGIN = 'DELETE_BENEFIT_BEGIN'
export const DELETE_BENEFIT_SUCCESS = 'DELETE_BENEFIT_SUCCESS'
export const DELETE_BENEFIT_ERROR = 'DELETE_BENEFIT_ERROR'

export const CREATE_BENEFIT_BEGIN = 'CREATE_BENEFIT_BEGIN'
export const CREATE_BENEFIT_SUCCESS = 'CREATE_BENEFIT_SUCCESS'
export const CREATE_BENEFIT_ERROR = 'CREATE_BENEFIT_ERROR'

export const UPDATE_BENEFIT_BEGIN = 'UPDATE_BENEFIT_BEGIN'
export const UPDATE_BENEFIT_SUCCESS = 'UPDATE_BENEFIT_SUCCESS'
export const UPDATE_BENEFIT_ERROR = 'UPDATE_BENEFIT_ERROR'

export const ADD_USER_BENEFIT_BEGIN = 'ADD_USER_BENEFIT_BEGIN'
export const ADD_USER_BENEFIT_SUCCESS = 'ADD_USER_BENEFIT_SUCCESS'
export const ADD_USER_BENEFIT_ERROR = 'ADD_USER_BENEFIT_ERROR'

export const DELETE_USER_BENEFIT_BEGIN = 'DELETE_USER_BENEFIT_BEGIN'
export const DELETE_USER_BENEFIT_SUCCESS = 'DELETE_USER_BENEFIT_SUCCESS'
export const DELETE_USER_BENEFIT_ERROR = 'DELETE_USER_BENEFIT_ERROR'

export const CLEAR_NEW_BENEFIT_STATE = 'CLEAR_NEW_BENEFIT_STATE'